<template>
  <div class="time-picker" ref="wrapperElement">
    <flat-pickr ref="timePicker" :placeholder="placeholder" v-model="arrivalTime" @on-close="onClosed" :config="timePickerConfig" class="form-control" :name="name"> </flat-pickr>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'

export default {
  name: 'time-picker',
  props: {
    value: {
      required: false,
    },
    minDate: {
      type: Date,
      required: false,
    },
    maxDate: {
      type: Date,
      required: false,
    },
    minuteIncrement: {
      type: Number,
      required: false,
    },
    name: {
      type: String,
      required: false,
      default: 'arrivalTime',
    },
    placeholder: {
      type: String,
      required: false,
    },
  },
  components: {
    flatPickr,
  },
  methods: {
    close() {
      this.$refs.timePicker.$el._flatpickr.close()
    },
    onClosed(value) {
      this.$emit('input', value)
    },
  },
  watch: {
    arrivalTime() {
      this.$emit('input', this.arrivalTime)
    },
  },
  data() {
    return {
      arrivalTime: this.value,
      timePickerConfig: {
        minuteIncrement: this.minuteIncrement,
        minDate: this.minDate,
        maxDate: this.maxDate,
        defaultDate: this.value,
        dateFormat: 'h:i K',
        enableTime: true,
        noCalendar: true,
        static: true,
      },
    }
  },
  mounted() {
    this.timePickerConfig.appendTo = this.$refs.wrapperElement
  },
}
</script>



// WEBPACK FOOTER //
// src/components/TimePicker.vue